<!--
******************************
 * @author Jesus R. Nava Cruz
 * @date May 24, 2023
 * @version 1.0
******************************
-->
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      no-data-text="Información no disponible"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-switch
          v-model="item.status"
          :false-value="0"
          :true-value="1"
          @change=" handleChangeStatus(item)"
        ></v-switch>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">       
        {{ $utilFront.formatDateTime(item.fecha) }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { headersLogs } from '../../../core/HeadersTable';
export default {
  name: "LogTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    update: Function,
    itemsPerPage: Number,
    listAllPagination: Function,
    model: Object,
  },
  data: () => ({
    headers: headersLogs,
    alertDialog: false,
  }),
  methods: {
    handleChangeStatus(item) {
      this.alertDialog = true;
      this.$swal({
        toast: true,
        title: "¿Sincronizar Registro?",
        confirmButtonText: "Sincronizar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      })
      .then((result) => {
        if (result.value) {
            this.alertDialog = false;
            this.model.idLog = item.idLog;
            this.model.status = item.status ? 1 : 0;
            this.update();
        } else {
            this.alertDialog = false
        }
      })
    },
  },
};
</script>